import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule, MatIconModule, MatInputModule, MatTableModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';
import { NgbDropdownModule, NgbRatingModule, NgbTabsetModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DxButtonModule, DxChartModule, DxCheckBoxModule, DxDataGridModule, DxLoadPanelModule, DxPopupModule, DxScrollViewModule, DxSelectBoxModule } from 'devextreme-angular';
import { CoreModule } from '../../../core/core.module';
import { PopupModule } from '../../component/popup/popup.module';
import { SharedModule } from '../../component/shared.module';
import { PartialsModule } from '../../partials/partials.module';
import { CheckinListComponent } from './checkin-list/checkin-list.component';
import { EditCheckinListComponent } from './checkin-list/edit-checkin-list/edit-checkin-list.component';
import { CxSurveyComponent } from './cx-survey/cx-survey.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { GuestConfirmationComponent } from './guest-confirmation/guest-confirmation.component';
import { InhouseListComponent } from './inhouse-list/inhouse-list.component';
import { EditMailTemplateComponent } from './mail-templates/edit-mail-template/edit-mail-template.component';
import { MailTemplatesComponent } from './mail-templates/mail-templates.component';
import { EditProfileComponent } from './profiles/edit-profile/edit-profile.component';
import { LoyalityCalculatorPipe } from './profiles/loyality-calculator.pipe';
import { ReservationDetailComponent } from './reservation-detail/reservation-detail.component';
import { ReservationComponent } from './reservation/reservation.component';
import { SendSmsComponent } from './send-sms/send-sms.component';
import { TasksComponent } from './tasks/tasks.component';

const routes: Routes = [
  { path: '', component: ReservationComponent },
  {
    path: 'reservation/:reservationid', component: ReservationDetailComponent, children: [
      { path: ':id', component: EditProfileComponent }
    ]
  },
  { path: 'checkin-profiles', component: CheckinListComponent },
  { path: 'guest-confirmation', component: GuestConfirmationComponent },
  { path: 'checkin-profiles/:id', component: EditCheckinListComponent },
  { path: 'tasks', component: TasksComponent },
  { path: 'survey', component: CxSurveyComponent },
  { path: 'mailstudio', component: MailTemplatesComponent },
  { path: 'mailstudio/:id', component: EditMailTemplateComponent },
  { path: 'inhouselist', component: InhouseListComponent },
  { path: 'sms', component: SendSmsComponent }
];

@NgModule({
  declarations: [
    DashboardComponent,
    CheckinListComponent,
    EditCheckinListComponent,
    ReservationComponent,
    TasksComponent,
    CxSurveyComponent,
    MailTemplatesComponent,
    EditMailTemplateComponent,
    SendSmsComponent,
    ReservationDetailComponent,
    InhouseListComponent,
    GuestConfirmationComponent,
    LoyalityCalculatorPipe
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    PartialsModule,
    MatFormFieldModule,
    MatTableModule,
    TranslateModule,
    NgxDatatableModule,
    FormsModule,
    DxButtonModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxPopupModule,
    DxScrollViewModule,
    PopupModule,
    CoreModule,
    NgbRatingModule,
    DxChartModule,
    NgbTabsetModule,
    SharedModule,
    NgbDropdownModule,
    MatInputModule,
    DxLoadPanelModule,
    MatIconModule
  ]
})
export class ActivityModule {
}
